import {
	type ConversationAction,
	HandleActionType,
	type SkillMetadata,
	type SkillMetadataMap,
} from '../../types';

/**
 * Returns skill metadata for a skill action by extracting the skill slug from the action's staticPrompt.
 *
 * Example: "/create-plan-release Create a release" -> "create-plan-release" -> metadata lookup
 */
export function getSkillMetadataForAction(
	action: ConversationAction | undefined,
	skillMetadataMap: SkillMetadataMap | undefined,
): SkillMetadata | undefined {
	if (
		!action ||
		!skillMetadataMap ||
		action.handleType !== HandleActionType.Skill ||
		!('staticPrompt' in action) ||
		!action.staticPrompt
	) {
		return undefined;
	}

	// Extract slash command from staticPrompt (first token)
	// e.g., "/create-plan-release Create a release" -> "create-plan-release"
	const firstToken = action.staticPrompt.trim().split(/\s+/, 1)[0];
	if (!firstToken) {
		return undefined;
	}

	const skillSlug = firstToken.startsWith('/') ? firstToken.slice(1) : null;
	return skillSlug ? skillMetadataMap[skillSlug] : undefined;
}
